// domain server
const apiServerPath = "https://bbl.bibly.kr:444";

// test server
//const apiServerPath = "http://test.ryencatchers.com:5001";

export default apiServerPath;
